package com.cybersoftsolution.cybersoftsolutionweb.components.menus

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.components.cards.MyPosition
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.GeneralKind
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.Element
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement

/**
<button class="btn btn-primary" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBothOptions" aria-controls="offcanvasWithBothOptions">Enable both scrolling & backdrop</button>

<div class="offcanvas offcanvas-start" data-bs-scroll="true" tabindex="-1" id="offcanvasWithBothOptions" aria-labelledby="offcanvasWithBothOptionsLabel">
<div class="offcanvas-header">
<h5 class="offcanvas-title" id="offcanvasWithBothOptionsLabel">Backdrop with scrolling</h5>
<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
</div>
<div class="offcanvas-body">
<p>Try scrolling the rest of the page to see this option in action.</p>
</div>
</div>


 */

@Composable
fun ToggleOffCanvasPanelElement(
    modifier: Modifier = Modifier,
    id: String,
    offCanvasPanelId: String,
    onClick: () -> Unit = {},
    content: @Composable () -> Unit
){
    Div(
        attrs = modifier
            .id(id)
            .onClick { onClick() }
//            .classNames("btn","btn-primary")
            .attrsModifier {
//                attr("type", "button")
                attr("data-bs-toggle", "offcanvas")
                attr("data-bs-target", "#$offCanvasPanelId")
                attr("aria-controls", offCanvasPanelId)
            }
            .toAttrs()
    ) {
        Box (
            modifier = Modifier
                .fillMaxSize()
        ) {
            content()
        }

    }

}

fun hideOffCanvasPanel(offCanvasPanelId: String="") {
    js("bootstrap.Offcanvas.getInstance(document.getElementById('sectionHiddenMenuPanelId')).hide();") as Unit
}


@Composable
fun OffCanvasPanel(
    style: CssStyle<GeneralKind>? = null,
    id: String,
    title: String = "",
    position: MyPosition = MyPosition.start,
    enableScrolling: Boolean = true,
    overlays: Boolean = true,
    showModal: Boolean = false,
    content: @Composable () -> Unit,

    ){
    val styleModifier = style?.toModifier() ?: Modifier

    Div(
        attrs = Modifier
            .id(id)
            .classNames("offcanvas","offcanvas-${position.name.lowercase()}")

            .thenIf(
                condition = !isDesktop(),
                other = Modifier.width(70.percent)
            )
//            .height(120.vh)
            .backgroundColor(Theme.Primary.rgb)

//            .height(50.px)
            .attrsModifier {
                attr("data-bs-scroll", "$enableScrolling")
                if (showModal) {
                    attr("data-bs-backdrop", "static")
                } else {
                    attr("data-bs-backdrop", "$overlays")
                }
//                attr("offcanvas-horizontal-width" , "10px")
                attr("tabindex", "-1")
                attr("aria-labelledby", "offcanvasWithBothOptionsLabel")
            }

            .toAttrs()
    ) {
        //Header
        Div(
            attrs = Modifier
                .classNames("offcanvas-header")
                .toAttrs()
        ) {

            if (position == MyPosition.end) {
                CloseButton()
                HeaderTitle(title,position)
            } else {
                HeaderTitle(title,position)
                CloseButton()
            }



        }

        //Body
        Div(
            attrs = Modifier
                .classNames("offcanvas-body")
                .toAttrs()
        ) {
            content()
        }
    }





}

@Composable
fun HeaderTitle(
    title: String,
    position: MyPosition
){
    //Header Title
    H5(
        attrs = Modifier

            .fillMaxWidth()
            .textAlign( if (position == MyPosition.end)  TextAlign.Right else TextAlign.Left)
            .classNames("offcanvas-title")
            .id("offcanvasWithBothOptionsLabel")
            .toAttrs()

    ) {
        Text(title)
    }

}

@Composable
fun CloseButton(){
    //Close Button
    Div(
        attrs = Modifier
            .cursor(Cursor.Pointer)
            .classNames("btn-close")
            .attrsModifier {
                attr("data-bs-dismiss", "offcanvas")
                attr("aria-label", "Close")
            }
            .toAttrs()
    ) {

    }
}